<div class="container">
  <div class="content-grid">
    <div class="user-profile">
      <img class="avatar-large" [src]="avatarImageUrl" />
      <app-avatar class="avatar-small" [image]="userInfo.avatarImage"></app-avatar>
      <div class="info">
        <div class="name">{{ userInfo.name || userInfo.username }}</div>
        @if (owner) {
          <div class="point">
            <app-user-economy [amount]="userInfo.points"></app-user-economy>
          </div>
        }
        @if (isTribeSelected && owner) {
          <button
            mat-raised-button
            [appThemedButton]="theme"
            class="btn-edit-profile"
            routerLink="/user/settings"
            [queryParams]="{ section: 'profile' }"
          >
            Edit profile
          </button>
        }
      </div>
    </div>

    <div class="content-container">
      <app-tag-menu
        [theme]="theme"
        [labels]="menuLabels"
        [selectedIndex]="selectedMenuIndex"
        (clickMenu)="onClickMenu($event)"
      ></app-tag-menu>

      <div class="profile-content">
        @if (currentSectionMenu.param == 'gifts') {
          <app-user-gifts [userInfo]="userInfo" [theme]="theme"></app-user-gifts>
        }
        @if (currentSectionMenu.param == 'topics') {
          <app-user-topics [theme]="theme"></app-user-topics>
        }
      </div>
    </div>
  </div>
</div>
